import attr from "./attr";
import belongsTo from "./belongs-to";
import hasMany from "./has-many";

const HasManyRelation = hasMany.HasManyRelation;

export { attr, belongsTo, hasMany, HasManyRelation };
